import { getAllRepairActions } from '@/services/rc/repair-actions.service'
import type { IRepairAction } from '@/types/rc/miners'
import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useRepairActionStore = defineStore('repair-actions', () => {
  const repairActions = ref<IRepairAction[]>([])

  /**
   * Gets all available repair services.
   */
  const getRepairActions = async () => {
    repairActions.value = await getAllRepairActions()
  }

  return {
    repairActions,
    getRepairActions,
  }
})
